import { render, staticRenderFns } from "./CoachStats.vue?vue&type=template&id=5253821c&scoped=true"
import script from "./CoachStats.vue?vue&type=script&lang=js"
export * from "./CoachStats.vue?vue&type=script&lang=js"
import style0 from "./CoachStats.vue?vue&type=style&index=0&id=5253821c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5253821c",
  null
  
)

export default component.exports